<template>
  <div class="box mybox">
    <div :class="['columns', { hidden: isFullScreen }]">
      <div class="column is-narrow">
        <div ref="qrcodeDom" id="qrcode" class="myqrcodebox"></div>
      </div>
      <div class="column">
        <div class="content">
          <h2 class="mytitle">图钉墙 3D 模型演示</h2>
          <p>第1步：打开微信扫一扫，扫描左侧二维码，启动浏览程序；</p>
          <p>第2步：在手机中查看与下图相同的3D作品。</p>
        </div>
      </div>
    </div>

    <div :class="['modelviewport', { fullscreen: isFullScreen }]">
      <div class="fullscreenbtn">
        <input
          type="button"
          :value="this.isFullScreen ? '还原' : '全屏'"
          v-on:click="this.toggleFullScreen"
        />
      </div>
      <gltf-viewer
        url="./models/scene.gltf" 
        :is-fullscreen = "this.isFullScreen"
      ></gltf-viewer>
    </div>
  </div>
</template>

<script>
import GltfViewer from "./components/GltfViewer";
import QRCode from "qrcodejs2";

export default {
  name: "app",
  components: {
    GltfViewer,
  },
  data() {
    return {
      isFullScreen: false,
    };
  },
  methods: {
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen;
    },
        // 生成二维码
    MakeQrcode(address) {
      new QRCode(this.$refs.qrcodeDom, {
        text: address, 
        width: 200, 
        height: 200, // 二维码高度
        colorDark: "#000000", // 二维码颜色
        colorLight: "#ffffff", // 背景颜色
        correctLevel: QRCode.CorrectLevel.H, // 校正水准
      });
    }
  },
  mounted() {
    this.isFullScreen = this.$route.query.isfullscreen === 'true';
    if(!this.isFullScreen) {
        let address = window.location.href
        let end = address.indexOf('?');
        if(end>-1) {
            address = address.substring(0,end);
            address += '#/?isfullscreen=true';
        } else {
          address += '?isfullscreen=true';
        }
        this.MakeQrcode(address);
    }
  },

  created() {
  },
};
</script>

<style lang="scss">
.column {
  width: 100%;
}
.fullscreenbtn {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 999999;
  opacity: 0.0
}
.modelviewport {
  position: relative;
}
.modelviewport.fullscreen {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
}

.hidden {
  display: none !important;
}
</style>
